<div class="info-options-order-body">
	<div class="details">
		<div class="details-inner details-top">
			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.option' | translate }}</h6>
				<div class="ticker">
					<span class="text">{{ order?.option_strike | price }}</span>
					<span
						class="text"
						highlight
						[isPositive]="order?.option_type === optionTypeEnum.CALL"
						[isNegative]="order?.option_type === optionTypeEnum.PUT"
						>{{ order?.option_type | uppercase }}</span
					>
					<span class="text">{{ order?.option_date | date: 'dd.MM.yyyy' }}</span>
				</div>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.orderType' | translate }}</h6>
				@if (order) {
					<span class="value">{{ 'ordersInfo.types.' + order.type | translate }}</span>
				}
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.orderDuration' | translate }}</h6>
				@if (order) {
					<span class="value">
						{{
							'ordersInfo.terms.' + (order.time_in_force | titleOrderTerm: order.extended_hours)
								| translate
						}}
					</span>
				}
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.quantity' | translate }}</h6>
				<span class="value">{{ order?.qty | quantity }}</span>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.executed' | translate }}</h6>
				<span class="value">{{ order?.filled_qty }}</span>
			</div>

			@if (order?.type === orderTypeEnum.LIMIT) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.limitPrice' | translate }}</h6>
					<span class="value">
						{{ order?.limit_price | price }}
					</span>
				</div>
			}

			@if (hasStatus(order, filledOrderStatuses)) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.avgFilledPrice' | translate }}</h6>
					<span class="value">{{ order?.filled_avg_price | price }}</span>
				</div>
			}

			@if (hasStatus(order, filledOrderStatuses)) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.brokerCommission' | translate }}</h6>
					<span class="value">{{ order?.commission_final | price }}</span>
				</div>
			}
		</div>

		@if (isOrderFilled && order?.is_close_position) {
			<div class="details-inner details-center">
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.profitability' | translate }}</h6>
					<div>
						<span
							highlight
							class="value"
							[isPositive]="(order?.profit_cash ?? 0) > 0"
							[isNegative]="(order?.profit_cash ?? 0) < 0"
							[isNeutral]="!order?.profit_cash"
						>
							{{ order?.profit_cash | price }}
						</span>

						<span
							highlight
							class="value"
							[isPositive]="(order?.profit_percent ?? 0) > 0"
							[isNegative]="(order?.profit_percent ?? 0) < 0"
							[isNeutral]="!order?.profit_percent"
						>
							({{ order?.profit_percent | profit: 'percent' }})
						</span>
					</div>
				</div>
			</div>
		}

		<div class="details-inner details-bottom">
			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.placed' | translate }}</h6>
				<span class="value">
					{{ order?.submitted_at ? (order?.submitted_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
				</span>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.updated' | translate }}</h6>
				<span class="value">
					{{ order?.updated_at ? (order?.updated_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
				</span>
			</div>

			@if (isOrderFilled) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.filled' | translate }}</h6>
					<span class="value">
						{{ order?.filled_at ? (order?.filled_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
					</span>
				</div>
			}

			@if (isOrderCanceled) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.canceled' | translate }}</h6>
					<span class="value">
						{{ order?.canceled_at ? (order?.canceled_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
					</span>
				</div>
			}

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.orderId' | translate }}</h6>
				<div class="right">
					<span class="value">{{ order?.id || '-' }}</span>
					@if (order?.id) {
						<tui-icon
							class="copy-icon"
							icon="@tui.copy"
							[clipboard]="order?.id"
						/>
					}
				</div>
			</div>
		</div>
	</div>
</div>
